module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc( "Login", "Log in" ) ))==null?'':__t)+
'</legend><div><label for="login-email-input">'+
((__t=( i18n.tc( "Login", "Email/Username:" ) ))==null?'':__t)+
'</label> <input type="text" autocomplete="username" id="login-email-input" data-input="login-email" value="'+
((__t=( email ))==null?'':__t)+
'" required></div><div><label for="login-password-input">'+
((__t=( i18n.tc( "Login", "Password:" ) ))==null?'':__t)+
'</label> <input type="password" autocomplete="current-password" id="login-password-input" data-input="login-password" required></div><div class="input"><small><a href="#" data-click="user-forgot">'+
((__t=( i18n.tc( "Login", "Forgot password?") ))==null?'':__t)+
'</a> ';
 if ( context !== "dual" ) { 
__p+=' | <a href="#" data-click="user-create">'+
((__t=( i18n.tc( "Login", "Register new account" ) ))==null?'':__t)+
'</a> ';
 } 
__p+=' </small></div><div class="only-browser"><input type="checkbox" id="login-remember-input" data-input="login-remember" checked="checked"> <label class="align-left" for="login-remember-input">'+
((__t=( i18n.tc( "Login", "Remember me" ) ))==null?'':__t)+
'</label></div></fieldset><fieldset class="button-wrap"><button class="primary" data-click="login-submit" disabled="disabled">'+
((__t=( i18n.tc( "Login", "Log in" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
